document.addEventListener("DOMContentLoaded", () => {
  const target = document.getElementById("judgeme_product_reviews");
  if (!target) return;

  // 执行一次补徽章逻辑
  const addBuyerBadges = (root = target) => {
    const authorWrappers = root.querySelectorAll(".jdgm-rev__author-wrapper");

    authorWrappers.forEach(wrapper => {
      // 检查内部是否已有徽章（即使多个也先清理到只剩一个）
      const existingBadges = wrapper.querySelectorAll(".jdgm-rev__buyer-badge-wrapper");

      if (existingBadges.length > 1) {
        // 多余的删除，只保留第一个
        for (let i = 1; i < existingBadges.length; i++) {
          existingBadges[i].remove();
        }
      } else if (existingBadges.length === 0) {
        // 没有则创建新的徽章
        const badgeWrapper = document.createElement("span");
        badgeWrapper.className = "jdgm-rev__buyer-badge-wrapper";
        badgeWrapper.innerHTML = '<span class="jdgm-rev__buyer-badge"></span>';


        // 插在作者名后
        const authorSpan = wrapper.querySelector(".jdgm-rev__author");
        if (authorSpan) authorSpan.insertAdjacentElement("afterend", badgeWrapper);
      }


    });

    // The revamp widget can use a different author wrapper in dynamically
    // loaded reviews. Cover those cards as well as the legacy Judge.me markup.
    root.querySelectorAll('.jdgm-rev, [class*="review-card"]').forEach(review => {
      if (review.querySelector('.jdgm-rev__buyer-badge-wrapper, .jdgm-rev__buyer-badge')) return;
      const author = review.querySelector('.jdgm-rev__author, .jm-review-author, [class*="review-author"]');
      if (!author) return;
      const wrapper = document.createElement('span');
      wrapper.className = 'jdgm-rev__buyer-badge-wrapper';
      wrapper.innerHTML = '<span class="jdgm-rev__buyer-badge" aria-label="Verified"></span>';
      author.insertAdjacentElement('afterend', wrapper);
    });

    root.querySelectorAll('.jm-reviewer-info__details').forEach(details => {
      const nativeBadge = details.querySelector('.jm-verified-buyer-badge:not(.product-verified-badge)');
      const insertedBadge = details.querySelector('.product-verified-badge');
      // Judge.me already owns the badge: never add a second one.
      if (nativeBadge) {
        if (insertedBadge) insertedBadge.remove();
        details.querySelectorAll('.jdgm-rev__buyer-badge-wrapper').forEach(node => node.remove());
        return;
      }
      const author = details.querySelector('.jm-reviewer-info__name');
      if (!author) return;
      const template = target.querySelector('.jm-verified-buyer-badge:not(.product-verified-badge)');
      // Do not create a fallback: Judge.me's scoped CSS depends on the
      // data-v attributes of a real rendered badge. Wait for that template.
      if (!template) return;
      const isScopedClone = insertedBadge && [...template.attributes]
        .filter(attribute => attribute.name !== 'class')
        .every(attribute => insertedBadge.getAttribute(attribute.name) === attribute.value);
      if (isScopedClone) return;
      if (insertedBadge) insertedBadge.remove();
      const badge = template.cloneNode(true);
      badge.classList.add('product-verified-badge');
      author.insertAdjacentElement('afterend', badge);
    });
  };

  // 初始化时执行
  addBuyerBadges();

  // 监听 DOM 变化（评论模块经常是动态插入的）
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        // 只处理新增的元素节点
        if (node.nodeType === 1) {
          addBuyerBadges(node);
        }
      });
    });
  });

  observer.observe(target, { childList: true, subtree: true });

  const bodyObserver = new MutationObserver(() => addBuyerBadges(document));
  bodyObserver.observe(document.body, { childList: true, subtree: true });
});


// 弹框切换逻辑
// 监听缩略图点击并等待弹框出现（轻量版）
(function () {
  // 等待弹框主容器出现（我们以 .jm-mfp-main 作为弹框“打开”的标志）
  function waitForPopupMain(timeout = 3000) {
    const existing = document.querySelector('.jm-mfp-main');
    if (existing) return Promise.resolve(existing);

    return new Promise((resolve, reject) => {
      const obs = new MutationObserver((mutations) => {
        for (const m of mutations) {
          for (const n of m.addedNodes) {
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches('.jm-mfp-main')) {
              cleanup();
              return resolve(n);
            }
            const found = n.querySelector?.('.jm-mfp-main');
            if (found) {
              cleanup();
              return resolve(found);
            }
          }
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });

      const to = setTimeout(() => {
        cleanup();
        reject(new Error('waitForPopupMain timeout'));
      }, timeout);

      function cleanup() {
        clearTimeout(to);
        try { obs.disconnect(); } catch (e) {}
      }
    });
  }

  // 只在弹框内更新 badge 的函数（不会 touch gallery 的节点）
  function updatePopupReviewBadge(reviewEl) {
    if (!reviewEl) return;
    try {
      const modernDetails = reviewEl.querySelector('.jm-reviewer-info__details');
      if (modernDetails) {
        const nativeBadge = modernDetails.querySelector('.jm-verified-buyer-badge:not(.product-verified-badge)');
        const insertedBadge = modernDetails.querySelector('.product-verified-badge');
        if (nativeBadge) {
          if (insertedBadge) insertedBadge.remove();
        } else {
          const author = modernDetails.querySelector('.jm-reviewer-info__name');
          const template = document.querySelector('#judgeme_product_reviews .jm-verified-buyer-badge:not(.product-verified-badge)');
          if (author && template) {
            const isScopedClone = insertedBadge && [...template.attributes]
              .filter(attribute => attribute.name !== 'class')
              .every(attribute => insertedBadge.getAttribute(attribute.name) === attribute.value);
            if (isScopedClone) return;
            if (insertedBadge) insertedBadge.remove();
            const badge = template.cloneNode(true);
            badge.classList.add('product-verified-badge');
            author.insertAdjacentElement('afterend', badge);
          }
        }
        return;
      }

      // 如果 Judgeme 已经渲染了它的 badge (.jdgm-rev__buyer-badge)，则不再插入 wrapper
      const hasNativeBadge = !!reviewEl.querySelector('.jdgm-rev__buyer-badge');
      const ourWrapper = reviewEl.querySelector('.jdgm-rev__buyer-badge-wrapper');

      // 如果是 verified：
    if (hasNativeBadge) {
      // 保留原生，移除我们自己的 wrapper
      if (ourWrapper) ourWrapper.remove();
      return;
    }

    // 如果没有原生 badge，就确保有我们自己的 badge
    if (!ourWrapper) {
      const authorEl = reviewEl.querySelector('.jdgm-rev__author'); // 正确！
      const jdgmRev = reviewEl.querySelector('.jdgm-rev');

      if (authorEl) {
        const wrapper = document.createElement('span');
        wrapper.className = 'jdgm-rev__buyer-badge-wrapper';
        wrapper.innerHTML = '<span class="jdgm-rev__buyer-badge" aria-label="Verified"></span>';

        // 插入到作者名字后面
        authorEl.insertAdjacentElement('afterend', wrapper);
      }
    }


    } catch (e) {
      console.error('updatePopupReviewBadge error', e);
    }
  }

  // 绑定 popupMain：监听其 review 区域的变化（只限弹框内）
  const boundPopups = new WeakSet();

  function bindPopupMain(popupMain) {
    if (!popupMain || boundPopups.has(popupMain)) return;
    boundPopups.add(popupMain);

    // 目标 wrapper（弹框内真实显示 review 的区）
    const reviewWrapper = popupMain.querySelector('.jm-mfp-review-wrapper') || popupMain;
    // 初次处理当前 review（弹框打开后立即）
    updatePopupReviewBadge(reviewWrapper.querySelector('.jdgm-rev'));

    // 创建 Observer，只关注 reviewWrapper 内「外部」变化
    const obs = new MutationObserver((mutations) => {
      let need = false;
      for (const m of mutations) {
        // 忽略我们自己插入/删除 wrapper 的变化（以类名判断）
        const addedOrRemoved = [...m.addedNodes, ...m.removedNodes].some(node =>
          node.nodeType === 1 && (node.classList.contains('jdgm-rev__buyer-badge-wrapper') || node.classList.contains('jdgm-rev__buyer-badge'))
        );
        if (addedOrRemoved) {
          // 如果变化完全是我们自己引起的，跳过
          continue;
        }

        // 如果 mutation 的 target 在 .jdgm-rev 内，则说明 review 内容被外部脚本更新，触发处理
        if (m.target && m.target.closest && m.target.closest('.jdgm-rev')) {
          need = true;
        }

        // 如果有直接的子节点替换，也需要触发
        if (m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length)) {
          need = true;
        }
      }

      if (need) {
        const reviewEl = reviewWrapper.querySelector('.jdgm-rev');
        updatePopupReviewBadge(reviewEl);
      }
    });

    obs.observe(reviewWrapper, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-verified-buyer'] });

    // 自动清理：当弹框整块从 DOM 移除时，断开 observer
    const removalObs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const r of m.removedNodes) {
          if (r === popupMain || (r.contains && r.contains(popupMain))) {
            try { obs.disconnect(); } catch (e) {}
            try { removalObs.disconnect(); } catch (e) {}
            boundPopups.delete(popupMain);
            return;
          }
        }
      }
    });

    removalObs.observe(document.body, { childList: true, subtree: true });

    // 另外，绑定弹框内 carousel 的点击（用户在弹框内切换缩略图/视频时触发一次）
    const carousel = popupMain.querySelector('.jm-mfp-carousel');
    if (carousel) {
      const handler = () => {
        // 延迟少量时间，等待第三方完成 DOM 更新
        setTimeout(() => {
          const reviewEl = reviewWrapper.querySelector('.jdgm-rev');
          updatePopupReviewBadge(reviewEl);
        }, 50);
      };
      carousel.addEventListener('click', handler, { passive: true });
      // 在 removalObs 清理时也会被移除（因为 carousel 在 popupMain 里，被移除时事件也随之释放）
    }
  }

  // 入口：监听 gallery 的点击（只用于等待弹框打开并绑定弹框，不直接修改 gallery）
  function initGalleryListener() {
    const gallery = document.querySelector('.jdgm-gallery');
    const delegator = gallery || document;

    delegator.addEventListener('click', (ev) => {
      const thumb = ev.target.closest('.jdgm-gallery__thumbnail-link, .jdgm-gallery__thumbnail-wrapper, .jdgm-gallery__thumbnail');
      if (!thumb) return;

      // 点击缩略图后等待弹框（基于 .jm-mfp-main）
      waitForPopupMain(3000)
        .then(popupMain => {
          bindPopupMain(popupMain);
        })
        .catch(() => {
          // 超时可以忽略
        });
    }, { passive: true });
  }

  // 启动：页面已存在弹框也处理一次（例如页面载入后弹框已打开）
  function start() {
    initGalleryListener();
    const existingPopup = document.querySelector('.jm-mfp-main');
    if (existingPopup) bindPopupMain(existingPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
